import { useFormatter } from "next-intl";
import React, { memo, useState } from "react";

import Input from "@/components/ui/Form/Input/Input";
import { IMortgageCalculatorInputAndLabel } from "@/types";

import MortgageCalculatorLabelAndIcon from "./MortgageCalculatorLabelAndIcon";

const MortgageCalculatorLabelInput: React.FC<IMortgageCalculatorInputAndLabel> = ({
  label = "",
  icon,
  iconTitle,
  customInputClass = "",
  inputName,
  inputValue,
  inputPlaceholder = "",
  inputLabel,
  handleChange = () => {},
  setDefaultValue = () => {},
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => handleChange(e.target.value);
  const [isEditable, setIsEditable] = useState(false);
  const format = useFormatter();
  // const value = parseFloat(e.target.value);
  // if (!isNaN(value)) {
  //   handleChange(value);
  // } else {
  //   handleChange(0);
  // }
  // };
  return (
    <div className="flex justify-between mb-xxs">
      <MortgageCalculatorLabelAndIcon label={label} icon={icon} iconTitle={iconTitle} />
      <div className="justify-end text-center relative flex border-b border-gray-10">
        {/* <Input
          className={`text-right pr-xxs flex-1 w-auto ${customInputClass}`}
          name={inputName}
          value={inputValue}
          placeholder={inputPlaceholder}
          onChange={handleInputChange}
        /> */}
        {isEditable && (
          <Input
            className={`text-right pr-xxs flex-1 w-auto ${customInputClass}`}
            name={inputName}
            value={inputValue}
            placeholder={inputPlaceholder}
            onChange={handleInputChange}
            onBlur={() => {
              setIsEditable((prev) => !prev);
              setDefaultValue();
            }}
            hideBorder={true}
          />
        )}
        {!isEditable && (
          <Input
            className={`text-right pr-xxs flex-1 w-auto ${customInputClass}`}
            name={inputName}
            value={typeof inputValue === "string" ? inputValue : format.number(Number(inputValue))}
            onFocus={() => setIsEditable((prev) => !prev)}
            hideBorder={true}
          />
        )}
        <div className="flex justify-center items-center">{inputLabel}</div>
      </div>
    </div>
  );
};

export default memo(MortgageCalculatorLabelInput);
